import { create } from "zustand";

export const useCommmonStore = create((set) => ({
  selected: "1",
  setSelected: (data) => set({ selected: data }),
}));
